import React, { SyntheticEvent } from 'react';
import { t } from 'i18next';
import './i18n';

export interface TimeAgoProps { lastEvent: Date | null, type: String | null }
export interface TimeAgoState { timeAgo: number | null }

export class TimeAgo extends React.Component<TimeAgoProps, TimeAgoState> {
    timer: number | null = null;

    constructor(props: TimeAgoProps) {
        super(props)
        this.state = { timeAgo: null };
    }

    componentDidMount() {
        this.timer = window.setInterval(() => this.tick(), 1000);
    }

    componentWillUnmount() {
        if (this.timer !== null)
            window.clearInterval(this.timer);
    }

    componentDidUpdate(prevProps: TimeAgoProps) {
        if (this.props.lastEvent !== prevProps.lastEvent)
            this.updateTimeAgo();
    }

    tick() {
        this.updateTimeAgo();
    }

    updateTimeAgo() {
        if (this.props.lastEvent === null) {
            this.setState({ timeAgo: null });
        } else {
            this.setState({ timeAgo: new Date().getTime() - this.props.lastEvent.getTime() })
        }
    }

    timeAgoDescription() {
        if (this.props.type === 'inv') {
            if (this.state.timeAgo === null)
                return t('Ongoing',{ns:'trans'});
            let count = Math.ceil(this.state.timeAgo / 1000);

            if (count < 60) {
                return t('s ago',{number:count, ns:'trans'});
                //return '< 1m ago'
            } else if (count < 3600) {
                return t('m ago',{number: Math.round(count / 60), ns:'trans'});
            } else if (count < 86400) {
                return t('h ago',{number: (count / 3600).toFixed(1), ns:'trans'}); //'h ago';
            } else if (count < 2592000) {
                return t('d ago',{number: Math.round(count / 86400), ns:'trans'}); //'d ago';
            } else if (count < 94608000) {
                return t('mo ago',{number: Math.round(count / 2592000), ns:'trans'}); //'mo ago';
            } else {
                return t('y ago',{number: Math.round(count / 94608000), ns:'trans'}); //'y ago';
            }

        } else {
            if (this.state.timeAgo === null)
                return 'No reports';

            let count = Math.ceil(this.state.timeAgo / 1000);
            let units = 'seconds';

            if (count > 120) {
                count = Math.ceil(count / 60)
                units = 'minutes';

                if (count > 120) {
                    count = Math.ceil(count / 60)
                    units = 'hours';

                    if (count > 72) {
                        count = Math.ceil(count / 24)
                        units = 'days';
                    }
                }
            }

            return `< ${count} ${units}`;
        }
    }

    toggleExpansion(event: SyntheticEvent) {

    }

    render() {
        return (
            <span className="TimeAgo">{this.timeAgoDescription()}</span>
        )
    }
}

export default TimeAgo
